export const navigation = [
  { label: 'Home', href: '/' },
  { label: 'Our Purpose', href: '/our-purpose' },
  {
    label: 'Product',
    href: '/products',
    children: [
      { label: 'Cattle Feed', href: '/products#Cattle%20Feed', description: 'Balanced nutrition for digestion, energy, and animal condition support.' },
      { label: 'Pig Feed', href: '/products#Pig%20Feed', description: 'Stage-wise swine feed positioning for farms and dealers.' },
      { label: 'Edible Oils', href: '/products#Edible%20Oils', description: 'Mustard, soybean, and sunflower oil enquiry support for trade partners.' }
    ]
  },
  { label: 'Quality', href: '/quality-research' },
  { label: 'Farmer Corner', href: '/farmer-corner' },
  { label: 'Dealer', href: '/dealer-partnership' },
  { label: 'Contact', href: '/contact' }
];

export const footerGroups = [
  {
    title: 'Products',
    links: [
      { label: 'Explore all products', href: '/products' },
      { label: 'Explore cattle feed products', href: '/products#Cattle%20Feed' },
      { label: 'Explore pig feed products', href: '/products#Pig%20Feed' },
    ]
  },
  {
    title: 'Edible Oils',
    links: [
      { label: 'Mustard Oil', href: '/edible-oils/mustard-oil' },
      { label: 'Soybean Oil', href: '/edible-oils/soybean-oil' },
      { label: 'Sunflower Oil', href: '/edible-oils/sunflower-oil' }
    ]
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', href: '/about' },
      { label: 'Our Purpose', href: '/our-purpose' },
      { label: 'Courage to Care', href: '/courage-to-care' },
      { label: 'Read our quality approach', href: '/quality-research' }
    ]
  },
  {
    title: 'Support & Guides',
    links: [
      { label: 'Farmer Corner', href: '/farmer-corner' },
      { label: 'Agritech Knowledge Hub', href: '/blog' },
      { label: 'Use cattle weight calculator', href: '/calculators/cattle' },
      { label: 'Use pig weight calculator', href: '/calculators/pig' },
      { label: 'Become a ZFAST dealer', href: '/dealer-partnership' },
      { label: 'Contact Us', href: '/contact' }
    ]
  }
];
